import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Alert,
    Label,
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { FileInput, generateFormData, Preview } from '../../../../helpers/ui/FileInput'
import Shimmer from "react-shimmer-effect";

import { Link, useHistory, Redirect } from "react-router-dom"
import Select from "react-select";

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import DatePicker from '../../../../helpers/ui/DatePicker'
import moment from 'moment'

class IndexView extends Component {

    createBloc = new CreateBloc();
    userdata = JSON.parse(localStorage.getItem('userdata'))

    constructor(props) {
        super(props)
        this.state = {
            loadingTitle: "Mengirim data...",
            successInfo: "Data berhasil disimpan",
            dataForm: {},
            dateList: [
                {
                    id: 1,
                    date: ""
                },
            ],
            failedInfo: "Gagal Terjadi Kesalahan",
            minDate: "",
            employee_wfh_letter_document_uuid: null,
            document: null
        }
    }

    checkNumber = (val) => {

        if (val == '') {
            alert('Mohon isi dulu Nomor ST!')
            return;
        }

        this.setState({
            loading: true,
            loadingTitle: "Mengecek Nomor Surat Tugas...",
            successInfo: "Berhasil",
        })

        this.createBloc.fetchCheckNumber({
            employee_wfh_letter_number: val
        })
    }

    addDate = () => {
        let count = this.state.dateList.length;
        this.setState({
            dateList: [
                ...this.state.dateList,
                {
                    id: count == 0 ? (count + 1) : this.state.dateList.slice(-1)[0].id + 1,
                    date: "",
                }
            ]
        })

        // console.log(this.state.dateList)
    }

    delDate = (data) => {
        console.log(data)
        this.setState({
            dateList: [
                ...this.state.dateList.filter((val) => val != data)
                // (count-1)
            ]
        })
    }

    handleChangeInputLevel = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.dateList];
        // 2. Make a shallow copy of the item you want to mutate
        let item = { ...items[index] };
        // 3. Replace the property you're intested in
        item.date = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({ dateList: items });
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.createBloc.fetchCreate(dataForm)
        // await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        console.log(values)
        if (this.hasDuplicatesValue(values.dates)) {
            alert('Terdapat Tanggal yang sama. Mohon dikoreksi!')
            return
        }

        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                employee_wfh_employee_uuid: this.userdata.employee_uuid,
                employee_wfh_employee_nip: this.userdata.employee_nip,
                employee_wfh_employee_name: this.userdata.employee_full_name
            },
            confirm: true,
            loadingTitle: "Mengirim data...",
            successInfo: "Data berhasil disimpan"
        })
    }

    checkDate = () => {
        let dates = this.state.dataForm.dates;

        this.createBloc.fetchCheckDate({
            employee_uuid: this.userdata.employee_uuid,
            dates: dates.join(',')
        })
    }

    hasDuplicatesValue = (array) => {
        return (new Set(array)).size !== array.length;
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                // this.submitData()

                this.checkDate()

                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.checkDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    this.setState({
                        used_dates_count: response.used_dates_count,
                        used_dates: response.used_dates
                    })

                    if (response.used_dates_count == 0) {
                        this.submitData()
                    } else {
                        this.setState({
                            failedInfo: response.message,
                            loading: false,
                            failed: true,
                        });
                    }
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break;
                default:
                    break;
            }
        })

        this.createBloc.checkNumberChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;

                    if (response != null) {
                        this.setState({
                            employee_wfh_letter_document_uuid: response.employee_wfh_letter_document_uuid,
                            document: response.document_letter,
                            loading: false
                        });
                    } else {
                        this.setState({
                            employee_wfh_letter_document_uuid: null,
                            document: null,
                            loading: false
                        });
                    }
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break;
                default:
                    break;
            }
        })

        this.createBloc.getMaxDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    console.log(response)
                    this.setState({ minDate: new Date() })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.createBloc.fetchMaxDate({ day: 5 })
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.checkDateChannel?.unsubscribe()
        this.createBloc.checkNumberChannell?.unsubscribe()
        this.createBloc.getMaxDateChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
            <Container fluid>
                <Row>
                <Col className="col-12">

                    <Card className="pegawai-rightbar">
                    <CardBody>
                        <CardTitle>Tambah Riwayat Angka Kredit</CardTitle>
                        <CardSubtitle className="mb-3">
                        Setiap isian yang bertanda (
                        <span className="text-danger">*</span>) adalah wajib diisi.
                        </CardSubtitle>
                        <hr />
                        <AvForm
                        className="needs-validation"
                        onValidSubmit={(e, values) =>
                            this.handlerOnSubmit(e, values)
                        }
                        >
                        <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                        Tipe Angka Kredit <span className="text-danger">*</span>
                    </Label>
                    <Col md="9">
                        <Select
                        name="credit_number_type"
                        options={[
                            { value: 1, label: "Tahunan" },
                            {
                            value: 2,
                            label: "Periodik",
                            },
                        ]}
                        onChange={(opt) => this.setState({ creditType: opt.value })}
                        defaultValue={this.state.creditType}
                        validate={{ required: { value: true } }}
                        />
                    </Col>
                    </Row>

                    <Row className="mb-3">
                            <label htmlFor="name" className="col-md-3 col-form-label">
                            Tahun {" "}
                            <span className="text-danger">*</span>
                            </label>
                            <Col md="5">
                            <AvField
                                name="start_year"
                                placeholder=" Tahun Mulai Penilaian..."
                                type="number"
                                errorMessage="Masukkan Tahun Mulai Penilaian"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="start_year"
                            />
                            </Col>
                        </Row>
                        



                    

                        <Row className="mb-3">
                            <label htmlFor="name" className="col-md-3 col-form-label">
                            Bulan Awal{" "}
                            <span className="text-danger">*</span>
                            </label>
                            <Col md="5">
                            <AvField
                                name="start_month"
                                placeholder=" Bulan Awal..."
                                type="number"
                                errorMessage="Masukkan Bulan Awal"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="start_month"
                            />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <label htmlFor="name" className="col-md-3 col-form-label">
                            Bulan Akhir{" "}
                            <span className="text-danger">*</span>
                            </label>
                            <Col md="5">
                            <AvField
                                name="end_month"
                                placeholder=" Bulan Akhir..."
                                type="number"
                                errorMessage="Masukkan Bulan Akhir"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="end_month"
                            />
                            </Col>
                        </Row>
                        
                        <Row className="mb-3">
                            <label htmlFor="name" className="col-md-3 col-form-label">
                            Jabatan
                            </label>
                            <Col md="5">
                            <AvField
                                name="jabatan"
                                type="text"
                                className="form-control"
                                id="jabatan"
                                value={this.state.emp_jabatan}
                                disabled={true}
                            />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <label htmlFor="name" className="col-md-3 col-form-label">
                            Angka Kredit{" "}
                            <span className="text-danger">*</span>
                            </label>
                            <Col md="5">
                            <AvField
                                name="secondary_credit"
                                placeholder=" Angka Kredit..."
                                type="number"
                                errorMessage="Masukkan Angka Kredit"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="secondary_credit"
                                onChange={this.handleTotalCreditChange}
                            />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <label htmlFor="name" className="col-md-3 col-form-label">
                            Ungah SKP <span className="text-danger">*</span>
                            </label>
                            <Col md="5">
                            <FileInput
                                name="file_skp"
                                validate={{ required: { value: true } }}
                                col="6"
                                isMultiple={false}
                                maxFiles={1}
                            />
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <label htmlFor="name" className="col-md-3 col-form-label">
                            Ungah PAK <span className="text-danger">*</span>
                            </label>
                            <Col md="5">
                            <FileInput
                                name="file_pak"
                                validate={{ required: { value: true } }}
                                col="6"
                                isMultiple={false}
                                maxFiles={1}
                            />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="3"></Col>
                            <Col md="9">
                            <Link to="/kepegawaian/home.html?riwayat_angkakredit">
                                <Button color="danger">
                                <i className="uil-arrow-left"></i> Kembali
                                </Button>
                            </Link>{" "}
                            <Button color="success" type="submit">
                                <i className="uil-arrow-up-right"></i> Simpan Data
                            </Button>
                            </Col>
                        </Row>
                        </AvForm>
                    </CardBody>
                    </Card>
                </Col>
                </Row>
            </Container>
            <ConfirmAlert
                confirmTitle="Konfirmasi!"
                confirmInfo="Apakah anda yakin akan menyimpan data ini?"
                loadingTitle="Mengirim data..."
                loadingInfo="Tunggu beberapa saat"
                successTitle="Berhasil!"
                successInfo="Data berhasil disimpan"
                failedTitle="Gagal!"
                failedInfo="Data gagal disimpan"
                showConfirm={this.state.confirm}
                showLoading={this.state.loading}
                showSuccess={this.state.success}
                showFailed={this.state.failed}
                response={this.confirmResponse}
            />
            {this.state.redirect ? (
                <Redirect to="/kepegawaian/home.html?riwayat_angkakredit" />
            ) : null}
            </Fragment>
        );
    }

}

export default IndexView